import { render, staticRenderFns } from "./ComprasAliasView.vue?vue&type=template&id=06975a1c&"
import script from "./ComprasAliasView.vue?vue&type=script&lang=js&"
export * from "./ComprasAliasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports